/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2023-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootReducers from "./root-reducer";
import rootSaga from "./root-saga";

const sagaMiddleware = createSagaMiddleware()

const store = configureStore({
    middleware: [sagaMiddleware],
    reducer: rootReducers,
    devTools: process.env.NODE_ENV === 'development',
})

sagaMiddleware.run(rootSaga);

export default store;
